import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { createDataTestId } from '../../../utils/test/testIds';
import { CircleBar, CircleFill, CircleRoot } from './Circle.styles';
const MIN_VALUE = 0.03;
export function Circle(_ref) {
  let {
    color,
    isCountdown,
    value,
    max,
    testId
  } = _ref;
  const valueRatio = value / max;
  const checkMinValue = valueRatio >= MIN_VALUE ? valueRatio : MIN_VALUE;
  const passedRatio = isCountdown ? valueRatio : checkMinValue;
  return React.createElement(CircleRoot, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68"
  }, createDataTestId(testId), {
    "data-component": "Circle"
  }), React.createElement(CircleBar, null), React.createElement(CircleFill, {
    color: color,
    value: passedRatio
  }));
}